import AttributeOption from "@/models/general/settings/RoadcubeMarket/AttributeOption";

export default {
    namespaced: true,

    state: () => ({
        attributeOption: new AttributeOption(),
        attributeOptions: []
    }),

    mutations: {
        setAttributeOptions(state, payload) {
            state.attributeOptions = payload || [];
        },

        setAttributeOption(state, payload) {
            state.attributeOption = new AttributeOption(payload);
        }
    },

    actions: {
        async getAttributeOptions({ commit }, q = "") {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await AttributeOption.getAttributeOptions(q);
                commit("setAttributeOptions", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },

        async create({ commit, dispatch }, body) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await AttributeOption.createAttributeOption(
                    body
                );
                commit("setLoading", false, { root: true });
                return data;
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },

        async update({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await AttributeOption.updateAttributeOption(
                    body.attribute_option_id,
                    body
                );
                commit("setLoading", false, { root: true });
                return data;
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },

        async delete({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await AttributeOption.deleteAttributeOption(
                    id
                );
                commit("setLoading", false, { root: true });
                return data;
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        }
    }
};
